import { get, post } from '../../../../util/api'
import * as type from './type'
import * as selector from './selector'

export const findInvoiceByIdRequest = () => ({
    type: type.FIND_INVOICE_BY_ID_REQUEST,
    payload: {},
})

export const findInvoiceByIdSuccess = (invoice) => ({
    type: type.FIND_INVOICE_BY_ID_SUCCESS,
    payload: {
        invoice,
    },
})

export const findInvoiceByIdError = (error) => ({
    type: type.FIND_INVOICE_BY_ID_ERROR,
    payload: {
        error,
    },
})


export const findInvoiceById = (invoiceId) => (dispatch, getState) => {
    if (!invoiceId) {
        return null
    }
    dispatch(findInvoiceByIdRequest())

    get('/api/invoice/find-by-id-full?invoiceId=' + invoiceId)
        .then(invoice => {
            dispatch(findInvoiceByIdSuccess(invoice))
        })
        .catch(error => {
            dispatch(findInvoiceByIdError(error))
        })
}


export const showConfirmationModal = () => ({
    type: type.SHOW_CONFIRMATION_MODAL,
})

export const closeConfirmationModal = () => ({
    type: type.CLOSE_CONFIRMATION_MODAL,
})

export const changeInvoiceCorrectionItem = (invoiceItemId, name, value) => ({
    type: type.CHANGE_INVOICE_CORRECTION_ITEM,
    payload: {
        invoiceItemId,
        name,
        value,
    },
})

export const changeInvoiceCorrectionData = (name, value) => ({
    type: type.CHANGE_INVOICE_CORRECTION_DATA,
    payload: {
        name,
        value,
    },
})


export const createInvoiceCorrectionRequest = () => ({
    type: type.CREATE_INVOICE_CORRECTION_REQUEST,
})

export const createInvoiceCorrectionError = (error) => ({
    type: type.CREATE_INVOICE_CORRECTION_ERROR,
    payload: {
        error,
    },
})

export const createInvoiceCorrectionSuccess = (invoiceCorrection) => ({
    type: type.CREATE_INVOICE_CORRECTION_SUCCESS,
    payload: {
        invoiceCorrection,
    },
})

export const createInvoiceCorrection = () => (dispatch, getState) => {
    const state = getState()
    const payload = selector.selectInvoiceCorrectionPayload(state)

    dispatch(createInvoiceCorrectionRequest())

    post('/api/invoice/create-partial-correction', payload)
        .then(invoiceCorrection => {
            dispatch(createInvoiceCorrectionSuccess(invoiceCorrection))
        })
        .catch(error => {
            dispatch(createInvoiceCorrectionError(error))
        })
}



// WEBPACK FOOTER //
// ./src/modules/invoice/state/correction/action.js